import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperclip2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPaperclip2"><Path fillRule="evenodd" clipRule="evenodd" d="M11 5.5C11 3.567 12.567 2 14.5 2C16.433 2 18 3.567 18 5.5V16C18 19.3137 15.3137 22 12 22C8.68629 22 6 19.3137 6 16V8H8V16C8 18.2091 9.79086 20 12 20C14.2091 20 16 18.2091 16 16V5.5C16 4.67157 15.3284 4 14.5 4C13.6716 4 13 4.67157 13 5.5V16H11V5.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperclip2;
